import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { SupportPlan } from '@/types/supportPlan';

export const getSupportPlan = async (id: number): Promise<ApiResult<SupportPlan>> => {
  const { status, result } = await callApi<SupportPlan>(
    `support-plans/${id}`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
